import { render, staticRenderFns } from "./LivingOptionSubsections.vue?vue&type=template&id=5b7735fb&scoped=true"
import script from "./LivingOptionSubsections.vue?vue&type=script&lang=js"
export * from "./LivingOptionSubsections.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionSubsections.vue?vue&type=style&index=0&id=5b7735fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7735fb",
  null
  
)

export default component.exports